import {
    Box,
    Checkbox, CircularProgress, Collapse,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer, TableFooter,
    TableHead,
    TablePagination,
    TableRow, TableSortLabel, Typography,
} from "@mui/material";
import {translate} from "../../translate/translate";
import * as React from "react";
import {useEffect, useState} from "react";
import TableMenuComponent from "../table-menu/table-menu.component";
import {useAuth} from "../../contexts/auth-context";
import {Value} from "./value-row-column.component";
import Divider from "@mui/material/Divider";
import {Choice} from "../../dto/choice";
import {ErrorComponent} from "../error/error.component";
import {DateTimeFormat} from "../date/date-timeFormat";
import IconButton from "@mui/material/IconButton";
import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import {formatNumber} from "../../utils/format-number";

const CollapsibleTableComponent = (props: any) => {
    const {
        displayedColumnsShow,
        displayedColumns,
        displayedTranslate,
        handleSwitch,
        disabledSwitch,
        columnStyles,
        field,
        fieldList,
        service,
        dateColumns,
        showActions,
        actionsHints,
        handleDuplicate,
        handleRowSelect,
        selectedRows,
        childrenObject,
        childrenComponent,
        rowsPerPageOptions=[5, 10, 25, 50],
        orderByColumns,
        orderByFn,
        orderBy,
        orderDirection,
        loading,
        loadOnOpen,
        customColumns,
        customCellRender,
        openControl,
        openKey = "id",
        goToDetail,
        numberColumns,
        currencyColumns,
        totalColumns,
        total,
        integerColumns,
        highlightedColumns,
        highlightedColor,
        customActions,
        highlightedHeader,
        handleAddChild,
        menuLayout = false,
        customMenuItems,
    } = props;
    const {user} = useAuth();

    const [choices, setChoices] = React.useState<Choice[]>([]);
    const [choicesList, setChoicesList] = React.useState<any>({});

    const getChoices = () => {
        if (field) {
            service.getChoices(field).then((response: any) => {
                setChoices(response?.map((item: any) => item));
            }).catch((error: any) => {
                ErrorComponent(error);
            });
        }
    };

    const getChoicesList = () => {
        if (fieldList) {
            fieldList.forEach((field: string) => {
                service.getChoices(field).then((response: any) => {
                    setChoicesList((value: any) => ({
                        ...value,
                        [field]: response?.map((item: any) => item)
                    }));
                }).catch((error: any) => {
                    ErrorComponent(error);
                });
            });
        }
    };

    useEffect(() => {
        getChoices();
        getChoicesList();
    }, []);

    const translateTitleColumn = (column: string, index: number): string => {
        return displayedColumnsShow === undefined || displayedColumnsShow.length !== displayedColumns.length
            ? translate.t(column)
            : translate.t(displayedColumnsShow[index]);
    };

    const translateRowColumn = (column: string, index: number, row: any): string => {
        const value = String(Value(row, column));
        return (
            (value === "" || value === undefined || value === null)
                ? "-"
                : (
                    displayedTranslate !== undefined && displayedTranslate.length > 0 &&
                    displayedTranslate.find((choice: any) => choice == column) !== undefined
                )
                    ? translate.t(value)
                    : value
        );
    };

    const changeSwitch = (row: any): boolean => {
        return "email" in row && "username" in row && row.id === user.id;
    };

    const dateFormat = (column: string, row: any) => {
        const date_str = String(Value(row, column))
            .replace(/^(\d{4})-(\d{2})-(\d{2})$/,
                (match, year, month, day) => `${day}/${month}/${year}`);

        const time_str = String(Value(row, column))
            .match(/(\d{2}):(\d{2})/);

        if (time_str != null){
            return DateTimeFormat(Value(row, column));
        }

        return date_str;
    };

    const isSwitch = (column: string): boolean => {
        return column === "is_superuser" || column === "is_active" || column === "active" || column === "default" || column === "is_top_bottom" || column === "status";
    };

    const isDate = (column: string): boolean => {
        return dateColumns === undefined
            ? false
            : dateColumns.includes(column);
    };

    const isNumber = (column: string): boolean => {
        return numberColumns === undefined
            ? false
            : numberColumns.includes(column);
    }

    const renderCell = (column: string, index: number, row: any) => {
        if (customColumns && customColumns.includes(column.toLocaleLowerCase())) {
            return customCellRender(column, index, row);
        }
        if (column === field) {
            const choice = choices.find((choice: any) => choice.value === row[column]);
            return choice?.display_name;
        }
        if (fieldList && fieldList.includes(column)) {
            const choice = choicesList[column].find((choice: any) => choice.value === row[column]);
            return choice?.display_name;
        }
        return column === "isRowSelectable" ? (
            <Checkbox
                checked={selectedRows.some((selectedRow: any) => selectedRow.id === row.id)}
                onChange={() => handleRowSelect(row)}
            />
        ) : isSwitch(column) ? (
            <Switch
                color="secondary"
                checked={Value(row, column)}
                onChange={() =>
                    !changeSwitch(row) && handleSwitch(row, column)
                }
                disabled={(row.id === user?.id && row.username === user?.username) || disabledSwitch}
            />
        ) : (
            isDate(column) ? dateFormat(column, row)
                : isNumber(column) ? formatNumber(Value(row, column), currencyColumns?.includes(column), integerColumns?.includes(column) ? 0 : 2)
                    : (
                        column === "color" ?
                            <Box
                                width="20px"
                                height="20px"
                                borderRadius="50%"
                                bgcolor={row[column]}
                            ></Box>
                            : translateRowColumn(column, index, row)
                    )
        );
    };

    const showPaginated = (from: number, to: number, count: number) => {
        return `${from} - ${to} ${translate.t("of")} ${count}`;
    };

    const totalStyle = {
        lineHeighteight: "48px",
        padding: "0 14px",
        fontSize: "14px",
        fontWeight: "600",
        color: "rgba(0, 0, 0, 0.87) !important",
        backgroundColor: "rgba(238,238,238,0.23)",
        paddingTop: "15px",
        paddingBottom: "15px",
    }

    const alignCell = (column: string) => {
        return numberColumns?.includes(column) ? "right" : "left";
    }

    const CollapsibleRow = ({
        displayedColumns,
        renderCell,
    }: {
        displayedColumns: string[];
        renderCell: (column: string, index: number, row: any) => JSX.Element | string;
    }) => {
        const [open, setOpen] = useState<boolean[]>([]);

        return (
            <>
                {props.state && props.state.length > 0 ? (
                    props.state.map((row: any) => (
                        <>
                            <TableRow
                                key={row.id}
                                sx={{"&:last-child td, &:last-child th": {border: 0}}}
                                onDoubleClick={() => {
                                    if (props.handleDoubleClick) {
                                        props.handleDoubleClick(row);
                                    }
                                }}
                            >
                                {displayedColumns
                                    .filter((obj: string) => obj !== "action")
                                    .map((column: string, index: any) => (
                                        <TableCell key={column}
                                                   sx={{wordBreak: "break-word",
                                                       fontSize: "14px",
                                                       fontWeight: index === 0 || currencyColumns?.includes(column) ? "bold !important" : "normal",
                                                       textAlign: alignCell(column),
                                                       backgroundColor: highlightedColumns?.includes(column) ? highlightedColor : undefined,
                                                    }}
                                        >
                                            {index === 0 && (
                                                <IconButton
                                                    aria-label="expand row"
                                                    size="small"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        event.preventDefault();
                                                        loadOnOpen && loadOnOpen(row);
                                                        setOpen((prev) => {
                                                           return {
                                                            ...prev,
                                                               [row.id]: !prev[row.id],
                                                            }
                                                        })
                                                    }}
                                                >
                                                    {openControl && openControl[row[openKey]] || open[openKey] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                </IconButton>
                                            )}
                                            {renderCell(column, index, row)}
                                        </TableCell>
                                    ))}
							  		{displayedColumns.includes("action") && !customActions && (
										<TableMenuComponent
											row={row}
											handleDelete={props.handleDelete}
											goToDetail={() => goToDetail(row)}
											url={props.url}
											handleOpenDialogHistory={props.handleOpenDialogHistory}
											editWithDialog={props.editWithDialog}
											showActions={showActions}
                                            actionsHints={actionsHints}
											handleDuplicate={handleDuplicate}
                                            handleAddChild={handleAddChild}
                                            customMenuItems={customMenuItems}
                                            menuLayout={menuLayout}
                                            backgroundColor={highlightedColumns?.includes("action") ? highlightedColor : undefined}
										/>
									)}
							  		{displayedColumns.includes("action") && customActions && (
										<TableCell>
										  	{customActions && (
												customCellRender(customActions, displayedColumns.length - 1, row)
										  	)}
										</TableCell>
									)}
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={displayedColumns.length} padding="none">
                                    <Collapse in={openControl && openControl[row[openKey]] || open[row[openKey]]} timeout="auto" unmountOnExit>
                                        <Box>
                                            {childrenComponent(row, childrenObject)}
                                        </Box>
                                    </Collapse>
                                </TableCell>
                            </TableRow>
                        </>
                    ))
                ) : (
                    <TableRow>
                        <TableCell
                            colSpan={displayedColumns.length}
                            sx={{
                                textAlign: "left",
                                fontSize: "14px",
                                padding: "8px"
                            }}
                        >
                            {translate.t("empty_listing")}
                        </TableCell>
                    </TableRow>
                )}
            </>
        );
    };

    return (
        <Box sx={{width: "100%"}}>
            <Paper>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                {/*<TableCell />*/}
                                {displayedColumns
                                    .filter((obj: string) => obj !== "action")
                                    .map((column: string, index: any) => (
                                        <TableCell
                                            key={column}
                                            sx={{
                                                lineHeighteight: "48px",
                                                padding: "0 14px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "rgba(0, 0, 0, 0.87) !important",
                                                backgroundColor: highlightedHeader && highlightedColumns?.includes(column) ? highlightedColor : '#EEEEEE',
                                                paddingTop: "15px",
                                                paddingBottom: "15px",
                                                width:
                                                    columnStyles && columnStyles[index + 1]
                                                        ? columnStyles[index + 1]
                                                        : undefined,
                                                textAlign: alignCell(column),
                                            }}
                                            sortDirection={orderBy?.replace("-", "") === column ? orderDirection : false}
                                        >
                                            {orderByColumns && orderByColumns.includes(column) ? (
                                                <TableSortLabel
                                                    color="rgba(0, 0, 0, 0.87) !important"
                                                    active={!!orderDirection && orderBy?.replace("-", "") === column}
                                                    direction={orderBy === column ? orderDirection : 'desc'}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        event.preventDefault();
                                                        orderByFn(column, orderDirection)
                                                    }}
                                                    hideSortIcon={false}
                                                    sx = {
                                                        {
                                                            color: 'rgba(0, 0, 0, 0.87) !important',
                                                            '& .MuiTableSortLabel-icon': {
                                                                color: 'rgba(0, 0, 0, 0.87) !important',
                                                            },
                                                        }
                                                    }
                                                >
                                                    {translateTitleColumn(column, index)}{orderBy === column}
                                                </TableSortLabel>
                                            ) : (
                                                <>{translateTitleColumn(column, index)}{orderBy === column}</>
                                            )}
                                        </TableCell>
                                    ))}
                                {displayedColumns.includes("action") && (
                                    <TableCell
                                        align="center"
                                        sx={{
                                            lineHeighteight: "48px",
                                            padding: "0 14px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            color: "rgba(0, 0, 0, 0.87) !important",
                                            backgroundColor: "#EEEEEE",
                                            paddingTop: "15px",
                                            paddingBottom: "15px",
                                            width: "0%"
                                        }}>
                                        {translate.t(customActions || "actions")}
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{cursor: "pointer"}}>
                            <CollapsibleRow
                                displayedColumns={displayedColumns}
                                renderCell={renderCell}
                            />
                        </TableBody>
                        {totalColumns && (<TableFooter>
                            <TableRow>
                                <TableCell colSpan={displayedColumns.filter((obj: string) => obj !== "action").length - totalColumns.length}
                                           sx={{
                                               ...totalStyle,
                                               textAlign: "right",
                                           }}
                                >
                                    Total
                                </TableCell>
                                {totalColumns.map((column: string, index: number) => (
                                    <TableCell key={column}
                                               sx={{
                                                   ...totalStyle,
                                                    width:
                                                        columnStyles && columnStyles[index + 1]
                                                            ? columnStyles[index + 1]
                                                            : undefined,
                                                   textAlign: "right",
                                                   backgroundColor: highlightedColumns?.includes(column) ? highlightedColor : 'rgba(238,238,238,0.23)'
                                                }}
                                    >
                                        {formatNumber(total[column], currencyColumns?.includes(column), integerColumns?.includes(column) ? 0 : 2)}
                                    </TableCell>
                                ))}
                                {displayedColumns.includes("action") && (
                                    <TableCell sx={totalStyle}></TableCell>
                                )}
                            </TableRow>
                        </TableFooter>)}
                    </Table>
                </TableContainer>
                <Divider/>
                <Box alignItems="center" display="flex" justifyContent="space-between" width="100%" paddingX="0.5rem">
                    {loading && <CircularProgress size="30px" />}
                    {props.page != undefined && <TablePagination
                        sx={{color: "#45485F", textAlign: "end", minHeight: "52px", maxHeight: "52px", width: "100%"}}
                        component="div"
                        rowsPerPageOptions={rowsPerPageOptions}
                        colSpan={12}
                        count={Number(props.count ?? 0)}
                        rowsPerPage={props.rowsPerPage}
                        page={props.page}
                        onPageChange={props.onPageChange}
                        onRowsPerPageChange={props.handleChangeRowsPerPage}
                        ActionsComponent={props.actionsComponent}
                        labelRowsPerPage={translate.t("rows_per_page")}
                        labelDisplayedRows={({from, to, count}) =>
                            showPaginated(from, to, count)
                        }
                    />}
                </Box>
            </Paper>
        </Box>
    );
};

export default CollapsibleTableComponent;
